import Component from './container/MealTimeGraphContainer'

export default Component
